<template>
  <div class="my-3">
    <router-link :to="`/tag/${catName(cat)}`" class="pill inline-block mr-2 hover:bg-black hover:text-white text-center" v-for="(cat, count) in event.category" :key="count">
      {{ catName(cat) }}
    </router-link>
    <router-link :to="`/tag/${cleanTag(tag)}`" class="pill inline-block mr-2 hover:bg-black hover:text-white text-center" v-for="(tag, count) in event.tags" :key="`tag-${count}`">
      {{ cleanTag(tag) }}
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  name: 'EventTags',

  props: ['event'],

  computed: {
    ...mapState(['lang', 'cats'])
  },

  data () {
    return {

    }
  },

  methods: {
    cleanTag (x) {
      return x.toLowerCase().replace(/_/g, ' ')
    },
    catName (cat) {
      if (this.lang === 'en') {
        return this.cleanTag(cat)
      } else {
        return this.cats[cat]
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
